module.exports = __webpack_public_path__ + "static/logoLeaf-6ce0055d7106227df79c4dc081d840e0.svg";